(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["guia-de-tallas-2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pethijos-recomendador-tallas')) {
    class PethijosRecomendadorTallas extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-recomendador-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-recomendador-panel]'));
        this.abortController = new AbortController();
        if (!this.tabs.length || !this.panels.length) return;
        const signal = this.abortController.signal;
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.activate(index), { signal });
          tab.addEventListener('keydown', (event) => this.onKeydown(event, index), { signal });
        });
        this.galleryStates = new Map();
        this.querySelectorAll('[data-recomendador-gallery]').forEach((gallery) => this.setupGallery(gallery, signal));
        document.addEventListener('shopify:block:select', (event) => this.onBlockSelect(event), { signal });
        document.addEventListener('click', (event) => this.onAnchorClick(event), { signal });
      }
      disconnectedCallback() { this.abortController?.abort(); }
      setupGallery(gallery, signal) {
        const slides = Array.from(gallery.querySelectorAll('[data-recomendador-gallery-slide]'));
        if (!slides.length) return;
        const state = { slides, index: 0, status: gallery.querySelector('[data-recomendador-gallery-status]') };
        this.galleryStates.set(gallery, state);
        gallery.querySelector('[data-recomendador-gallery-previous]')?.addEventListener('click', () => this.changeGallerySlide(gallery, -1), { signal });
        gallery.querySelector('[data-recomendador-gallery-next]')?.addEventListener('click', () => this.changeGallerySlide(gallery, 1), { signal });
        this.showGallerySlide(gallery, 0);
      }
      changeGallerySlide(gallery, direction) {
        const state = this.galleryStates.get(gallery);
        if (!state) return;
        this.showGallerySlide(gallery, state.index + direction);
      }
      showGallerySlide(gallery, index) {
        const state = this.galleryStates.get(gallery);
        if (!state) return;
        const nextIndex = (index + state.slides.length) % state.slides.length;
        state.slides.forEach((slide, slideIndex) => { slide.hidden = slideIndex !== nextIndex; });
        state.index = nextIndex;
        if (state.status) state.status.textContent = `${nextIndex + 1} / ${state.slides.length}`;
      }
      activate(index, moveFocus = false) {
        const nextIndex = Math.max(0, Math.min(index, this.tabs.length - 1));
        this.tabs.forEach((tab, tabIndex) => {
          const active = tabIndex === nextIndex;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });
        this.panels.forEach((panel, panelIndex) => { panel.hidden = panelIndex !== nextIndex; });
        if (moveFocus) this.tabs[nextIndex].focus();
      }
      onKeydown(event, index) {
        let nextIndex = null;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;
        if (nextIndex === null) return;
        event.preventDefault();
        this.activate(nextIndex, true);
      }
      onBlockSelect(event) {
        const panel = event.target.closest('[data-recomendador-panel]');
        if (!panel || !this.contains(panel)) return;
        const index = this.panels.indexOf(panel);
        if (index >= 0) this.activate(index);
      }
      onAnchorClick(event) {
        const link = event.target.closest('a[href="#recomendador-de-tallas"]');
        if (!link) return;
        event.preventDefault();
        this.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      }
    }
    customElements.define('pethijos-recomendador-tallas', PethijosRecomendadorTallas);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-guide"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pethijos-size-guide')) {
    class PethijosSizeGuide extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-size-track]');
        this.slides = Array.from(this.querySelectorAll('[data-size-slide]'));
        this.previousButton = this.querySelector('[data-size-prev]');
        this.nextButton = this.querySelector('[data-size-next]');
        this.currentLabel = this.querySelector('[data-size-current]');
        this.currentIndex = 0;
        this.scrollFrame = null;
        this.touchStartX = 0;
        this.touchStartY = 0;
        this.touchStartIndex = 0;
        this.touchActive = false;
        this.abortController = new AbortController();

        if (!this.track || this.slides.length < 1) return;

        const signal = this.abortController.signal;

        this.previousButton?.addEventListener('click', () => this.goTo(this.currentIndex - 1), { signal });
        this.nextButton?.addEventListener('click', () => this.goTo(this.currentIndex + 1), { signal });
        this.track.addEventListener('scroll', () => this.onScroll(), { passive: true, signal });
        this.track.addEventListener('touchstart', (event) => this.onTouchStart(event), { passive: true, signal });
        this.track.addEventListener('touchend', (event) => this.onTouchEnd(event), { passive: true, signal });
        this.track.addEventListener('touchcancel', () => this.cancelTouch(), { passive: true, signal });
        window.addEventListener('resize', () => this.update(), { passive: true, signal });

        document.addEventListener(
          'shopify:block:select',
          (event) => {
            const selectedSlide = event.target.closest('[data-size-slide]');
            if (!selectedSlide || !this.contains(selectedSlide)) return;

            const selectedIndex = this.slides.indexOf(selectedSlide);
            if (selectedIndex >= 0 && window.matchMedia('(max-width: 749px)').matches) {
              this.goTo(selectedIndex, false);
            }
          },
          { signal }
        );

        this.update();
      }

      disconnectedCallback() {
        this.abortController?.abort();
        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
      }

      onScroll() {
        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => this.update());
      }

      onTouchStart(event) {
        if (!window.matchMedia('(max-width: 749px)').matches || event.touches.length !== 1) return;

        const touch = event.touches[0];
        this.touchStartX = touch.clientX;
        this.touchStartY = touch.clientY;
        this.touchStartIndex = this.currentIndex;
        this.touchActive = true;
      }

      onTouchEnd(event) {
        if (!this.touchActive || event.changedTouches.length < 1) return;

        const touch = event.changedTouches[0];
        const deltaX = touch.clientX - this.touchStartX;
        const deltaY = touch.clientY - this.touchStartY;
        const absoluteX = Math.abs(deltaX);
        const absoluteY = Math.abs(deltaY);
        const isHorizontalSwipe = absoluteX >= 36 && absoluteX > absoluteY * 1.35;
        const startIndex = this.touchStartIndex;

        this.cancelTouch();

        if (!isHorizontalSwipe) return;
        this.goTo(startIndex + (deltaX < 0 ? 1 : -1));
      }

      cancelTouch() {
        this.touchActive = false;
      }

      update() {
        if (!this.track || this.slides.length < 1) return;

        const trackCenter = this.track.scrollLeft + this.track.clientWidth / 2;
        let closestIndex = 0;
        let closestDistance = Number.POSITIVE_INFINITY;

        this.slides.forEach((slide, index) => {
          const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
          const distance = Math.abs(trackCenter - slideCenter);

          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        this.currentIndex = closestIndex;
        if (this.currentLabel) this.currentLabel.textContent = String(closestIndex + 1);
        if (this.previousButton) this.previousButton.disabled = closestIndex === 0;
        if (this.nextButton) this.nextButton.disabled = closestIndex === this.slides.length - 1;
      }

      goTo(index, smooth = true) {
        if (!this.track || this.slides.length < 1) return;

        const nextIndex = Math.max(0, Math.min(index, this.slides.length - 1));
        const slide = this.slides[nextIndex];
        const left = slide.offsetLeft - (this.track.clientWidth - slide.offsetWidth) / 2;

        this.track.scrollTo({
          left,
          behavior: smooth && !window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'auto'
        });
      }
    }

    customElements.define('pethijos-size-guide', PethijosSizeGuide);
  }

  } catch(e) { console.error(e); }
})();
})();
